// Distance de course (DistanceCourse cote serveur) : celle a laquelle un
// modele de seance est destine (null = toutes distances), et celle que
// prepare un athlete, fixee par son coach. Le coach ne voit, pour choisir
// les modeles d'un athlete, que ceux de sa distance et ceux « toutes distances ».
import { type Seance } from './seancesApi.ts';

export type DistanceCourse = 'CINQ' | 'DIX' | 'SEMI' | 'MARATHON';

export const DISTANCES: { code: DistanceCourse; libelle: string }[] = [
  { code: 'CINQ', libelle: '5 km' },
  { code: 'DIX', libelle: '10 km' },
  { code: 'SEMI', libelle: 'Semi-marathon' },
  { code: 'MARATHON', libelle: 'Marathon' },
];

/** Libelle d'une distance ; null si absente ou inconnue. */
export function libelleDistance(code: string | null | undefined): string | null {
  return DISTANCES.find((d) => d.code === code)?.libelle ?? null;
}

/** Le modele convient a la distance (pas de distance choisie : tous conviennent). */
export function convientA(modele: Seance, distance: string | null | undefined): boolean {
  return !distance || !modele.distanceCourse || modele.distanceCourse === distance;
}

/** Nom d'un modele suivi de sa distance, ex « Modele fractionne (Marathon) ». */
export function nomAvecDistance(modele: Seance): string {
  const d = libelleDistance(modele.distanceCourse);
  return d ? `${modele.nom} (${d})` : modele.nom;
}
